fr:
  acceptInvite:
    continueWithFacebookText: 'Ou, continuez avec Facebook'
    firstNameLabel: Prénom
    firstNamePlaceholder: Votre Prénom
    helloFNameText: 'Bonjour {{fName}}'
    lastNameLabel: Nom de famille
    lastNamePlaceholder: Votre Nom de famille
    otpLabel: Activez 2FA
    passwordConfirmationPlaceholder: Confirmez votre mot de passe
    passwordError: 'Mot de passe {{passwordError}}'
    passwordErrorRequired: Veuillez saisir votre mot de passe
    passwordLabel: 'Mot de passe '
    passwordPlaceholder: Ajoutez votre mot de passe
    signInWithFacebookBtn: Se connecter avec Facebook
    signUpBtn: Se connecter
    welcomeToSRText: Bienvenue à Shuttlerock
  alert:
    goBack: Retour
    notFoundTitle: Page Non trouvée
    oopsOhNoTitle: Oh Non!
    oopsTryAgainLaterText: "Réessayez plus tard. Si ce problème n'est pas réparé d'ici peu, veuillez contacter not equipe de maintenance."
    orderThanksText: 'Votre commande a été reçu, vous recevrez un email de confirmation sous peu.'
    orderThanksTitle: Merci pour votre commande
    orderThanksTrackYourOrderButton: Guardez un oeil sur vos commandes
  authForm:
    emailErrorEmail: Ceci n'est pas un email valide
    emailErrorRequired: Champs requis
    emailLabel: Addresse email
    emailPlaceholder: Addresse email
    forgotPasswordLink: Mot de passe oublié?
    passwordLabel: Mot de passe
    passwordPlaceholder: Mot de passe
    signInBtn: Se connecter
    signInError: There seems to be a connection issue. Please try again or contact support.
    signInWithFacebookBtn: Se connecter avec Facebook
  common:
    loadMoreBtn: Plus
